// COULEUR TITLE
document.addEventListener("DOMContentLoaded", function () {
	const colors = ["#AD5994", "#51B1E1", "#51AE7F", "#CCC262", "#CE7D38", "#C14A44"];
	const words = document.querySelectorAll(".mm-title-rainbow");

	words.forEach(function (word, index) {
		// Appliquer la couleur
		word.style.color = colors[index % colors.length];

		// Ajouter la classe directionnelle dès maintenant
		const direction = index % 2 === 0 ? "from-right" : "from-left";
		word.classList.add(direction);

		// Forcer un reflow ici (clé pour que les transitions démarrent bien)
		void word.offsetWidth;

		// Ajouter la classe "appear" en décalé
		setTimeout(function () {
			word.classList.add("appear");
		}, index * 200);
	});
});